import {Form, Input, Modal, Select, Typography} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {useAdminGroupSaleCreateMutation} from '../../../gen/api/apis';
import {AdminCreateGroupSale} from '../../../gen/api/models';
import {useNotification} from '../../../NotificationContext';

export interface GroupSaleCreateModalProps {
    onEnd: () => void;
    open: boolean;
}

export const GroupSaleCreateModal = (props: GroupSaleCreateModalProps) => {
    const notify = useNotification();
    const navigate = useNavigate();

    const [form] = Form.useForm<AdminCreateGroupSale>();

    const createGroupSale = useAdminGroupSaleCreateMutation({
        onSuccess() {
            notify.openNotificationWithIcon('success', 'Group Sale created successfully');
            props.onEnd();
        },
        onError(error) {
            console.error(error);
            notify.openNotificationWithIcon('error', 'Error creating group sale');
            props.onEnd();
        },
    });

    const create = () => {
        form.validateFields()
            .then((values) => {
                createGroupSale.mutate({
                    params: values,
                });
            })
            .catch((error) => {
                console.error('Validation failed:', error);
            });
    };

    return (
        <Modal
            open={props.open}
            onCancel={() => {
                props.onEnd();
            }}
            onOk={create}
            width={400}
            title={'Create Group Sale List'}
            centered
            destroyOnClose
            modalRender={(dom) => (
                <Form
                    layout="vertical"
                    form={form}
                    name="newGroupSale"
                    clearOnDestroy
                    onFinish={() => create()}
                >
                    {dom}
                </Form>
            )}
            okText="Create"
            cancelText="Cancel"
        >
            <Form.Item
                label={<Typography.Text strong>Name</Typography.Text>}
                name="name"
                rules={[{required: true, message: 'Please input the group sale name!'}]}
            >
                <Input placeholder="Enter group sale name" />
            </Form.Item>
            <Form.Item
                label={<Typography.Text strong>Status</Typography.Text>}
                name="status"
                rules={[{required: true, message: 'Please select the group sale status!'}]}
            >
                <Select placeholder="Select group sale status">
                    <Select.Option value="active">Active</Select.Option>
                    <Select.Option value="inactive">Inactive</Select.Option>
                </Select>
            </Form.Item>
        </Modal>
    );
};
